module.exports = __webpack_public_path__ + "98311456903486ecf6f8f705bee85781.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Material-Design-Icons.svg?-g7cqhn
// module id = 1550
// module chunks = 0